// Define the enum OfferStatus
enum PmOfferStatus {
  Lead = 'Lead',
  Aprobata = 'Aprobata',
  Comunicata = 'Comunicata',
  Renegociere = 'Renegociere',
  Licitatie = 'Licitatie',
  Licitatie_cu_risc = 'Licitatie_cu_risc',
  Acceptata = 'Acceptata',
  Refuzat = 'Refuzat',
  Contract_semnat = 'Contract_semnat',
}

export default PmOfferStatus;
